(() => {
  let pubSubBound = false;

  const patchCartItems = () => {
    const CartItemsClass = window.CartItems;
    if (!CartItemsClass?.prototype || CartItemsClass.prototype.fmQuantityValidationPatched) return;

    const proto = CartItemsClass.prototype;
    proto.fmQuantityValidationPatched = true;

    proto.validateQuantity = function validateQuantity(event) {
      const input = event?.target;
      if (!input?.dataset) return;

      const inputValue = Number.parseInt(input.value, 10);
      const index = input.dataset.index;
      const min = Number.parseInt(input.dataset.min, 10);
      const max = Number.parseInt(input.max, 10);
      const step = Number.parseInt(input.step, 10) || 1;
      const strings = window.quickOrderListStrings || {};
      let message = '';

      if (!Number.isFinite(inputValue) || inputValue < 0) {
        message = window.cartStrings?.error || 'Invalid quantity';
      } else if (inputValue !== 0 && Number.isFinite(min) && inputValue < min) {
        message = (strings.min_error || 'Minimum quantity is [min]').replace('[min]', min);
      } else if (Number.isFinite(max) && inputValue > max) {
        message = (strings.max_error || 'Maximum quantity is [max]').replace('[max]', max);
      } else if (inputValue !== 0 && inputValue % step !== 0) {
        message = (strings.step_error || 'Quantity must be in increments of [step]').replace('[step]', step);
      }

      if (message) {
        this.setValidity(event, index, message);
        return;
      }

      input.setCustomValidity('');
      input.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        event,
        document.activeElement?.getAttribute?.('name') || input.getAttribute('name'),
        input.dataset.quantityVariantId
      );
    };
  };

  const bindCartUpdates = () => {
    if (pubSubBound || typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined' || !PUB_SUB_EVENTS.cartUpdate) return;
    pubSubBound = true;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (event = {}) => {
      const drawer = document.querySelector('cart-drawer');
      const count = event.cartData?.item_count;
      if (Number.isFinite(count)) drawer?.syncHeaderCartCount?.(count);
      else drawer?.refreshHeaderCartCount?.();
      queueMicrotask(() => drawer?.upgradeTrustProof?.());
    });
  };

  const init = () => {
    patchCartItems();
    bindCartUpdates();
  };

  init();
  document.addEventListener('shopify:section:load', init);
})();
